/*
 * @Author: 刘小博
 * @Date: 2023-02-07 14:25:00
 * @LastEditTime: 2023-02-27 11:22:50
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\work-center\modules\visitActivityRouter.js
 * 拜访活动
 */
import { getAuthClientList } from '@/api/common'
import store from '@/store'

const visitActivityRouter = [
  // 拜访、协访列表 meta_type 1-拜访，2-协访
  {
    path: '/behaviorManage/visiting/:meta_type',
    name: 'behaviorManageVisitingPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisiting" */
      //   '@/views/behaviorManage/visiting/Page.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisiting" */
        '@/views/behavior-manage/work-center/visit-activity/visit-coopreative/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访',
      },
      2: {
        title: '协访',
      },
    },
  },
  // 拜访详情
  {
    path: '/behaviorManage/visiting/detail/:meta_type/:id',
    name: 'behaviorManageVisitingDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageVisiting" */
      //   '@/views/behaviorManage/visiting/Detail.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"behaviorManageVisiting" */
        '@/views/behavior-manage/work-center/visit-activity/visit-coopreative/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      isMoreMeta: true,
      1: {
        title: '拜访详情',
        breadcrumb: [
          {
            title: '拜访',
            path: '/behaviorManage/visiting/1',
          },
        ],
      },
      2: {
        title: '协访详情',
        breadcrumb: [
          {
            title: '协访',
            path: '/behaviorManage/visiting/2',
          },
        ],
      },
    },
  },
  //导入拜访
  {
    path: '/behaviorManage/visiting/import/:type',
    name: 'behaviorManageVisitingImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem4" */
      //   '@/views/behaviorManage/visiting/ClientImport.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"flowSystem4" */
        '@/views/behavior-manage/work-center/visit-activity/visit-coopreative/Import.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '导入拜访',
      breadcrumb: [
        {
          title: '拜访列表',
          path: '/behaviorManage/visiting/1',
        },
      ],
    },
    beforeEnter(to, from, next) {
      getAuthClientList([1, 2, 3, 4, 7]).then((res) => {
        if (0 === res.status) {
          let classList = res.data.classList
          store.commit('setClientClassList', classList)
        }
        next()
      })
    },
  },

  // 签到签离地图 meta_type 1-拜访 2-活动
  {
    path: '/behaviorManage/signin-map/:id/:meta_type/:parentParams',
    name: 'behaviorManageSigninMap',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageSigninMap" */
      //   '@/views/behaviorManage/visiting/SigninMap'
      // ),  待删除文件
      import(
        /*webpackChunkName:"behaviorManageSigninMap" */
        '@/views/behavior-manage/work-center/visit-activity/visit-coopreative/Map.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      isMoreMeta: true,
      1: {
        title: '签到签离位置',
        breadcrumb: [
          {
            title: '拜访列表',
            name: 'behaviorManageVisitingPage',
          },
        ],
      },
      2: {
        title: '签到签离位置',
        breadcrumb: [
          {
            title: '活动列表',
            name: 'behaviorManageBazaarActivityList',
          },
        ],
      },
    },
  },

  // 医院开发列表
  {
    path: '/behaviorManage/new-hospital',
    name: 'behaviorManageNewHospital',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/newHospital/List.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-develop/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '医院开发',
    },
  },
  // 医院开发 详情
  {
    path: '/behaviorManage/new-hospital-detail/:id',
    name: 'behaviorManageNewHospitalDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/newHospital/Detail.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-develop/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '医院开发详情',
      breadcrumb: [
        {
          title: '医院开发',
          name: 'behaviorManageNewHospital',
        },
      ],
    },
  },
  // 医院开发 医院开发设置
  {
    path: '/behaviorManage/hospital-goods-setting',
    name: 'behaviorManageNewHospitalGoodsSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/newHospital/GoodsSetting.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-develop/Edit.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '医院开发设置',
      breadcrumb: [
        {
          title: '医院开发',
          name: 'behaviorManageNewHospital',
        },
      ],
    },
  },

  // 医院开发 导出
  {
    path: '/behaviorManage/new-hospital/export',
    name: 'behaviorManageNewHospitalExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageNewHospitalExploit" */
      //   '@/views/behaviorManage/newHospital/Export.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageNewHospitalExploit" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-develop/Export.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '导出',
      breadcrumb: [
        {
          title: '医院开发',
          name: 'behaviorManageNewHospital',
        },
      ],
    },
  },

  // 医院上量
  {
    path: '/behaviorManage/old-hospital-list',
    name: 'behaviorManageOldHospitalList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalList" */
      //   '@/views/behaviorManage/OldHospitalList.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalList" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-volume/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '医院上量',
    },
  },
  // 医院上量 详情
  {
    path: '/behaviorManage/old-hospital-details/:json',
    name: 'behaviorManageOldHospitalDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/OldHospitalDetails.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-volume/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '医院上量详情',
      breadcrumb: [
        {
          title: '医院上量',
          name: 'behaviorManageOldHospitalList',
        },
      ],
    },
  },
  // 医院上量设置
  {
    path: '/behaviorManage/old-hospital-set',
    name: 'behaviorManageOldHospitalSet',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/OldHospitalSet.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-volume/Edit.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '医院上量设置',
      breadcrumb: [
        {
          title: '医院上量',
          name: 'behaviorManageOldHospitalList',
        },
      ],
    },
  },

  // 医院上量 导出
  {
    path: '/behaviorManage/old-hospital-export',
    name: 'behaviorManageOldHospitalExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/OldHospitalExport.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/visit-activity/hospital-volume/Export.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '导出',
      breadcrumb: [
        {
          title: '医院上量',
          name: 'behaviorManageOldHospitalList',
        },
      ],
    },
  },

  // 行为管理 市场活动列表
  {
    path: '/behaviorManage/bazaarActivity/list',
    name: 'behaviorManageBazaarActivityList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage1" */
      //   '@/views/behaviorManage/bazaarActivity/List.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManage1" */
        '@/views/behavior-manage/work-center/visit-activity/market-activity/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '市场活动',
    },
  },
  // 行为管理 市场活动 导出页
  {
    path: '/behaviorManage/bazaarActivity/export/:parameter',
    name: 'behaviorManageBazaarActivityExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage2" */
      //   '@/views/behaviorManage/bazaarActivity/Export.vue'
      // ),
      import(
        /*webpackChunkName:"behaviorManage2" */
        '@/views/behavior-manage/work-center/visit-activity/market-activity/Export.vue'
      ), //.新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '导出',
      breadcrumb: [
        {
          title: '市场活动',
          name: 'behaviorManageBazaarActivityList',
        },
      ],
    },
  },

  // 行为管理 市场活动 详情
  {
    path: '/behaviorManage/bazaarActivity/details/:id/:type/:is_replace/:approval_id',
    name: 'behaviorManageBazaarActivityDetails',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage2" */
      //   '@/views/behaviorManage/bazaarActivity/Details.vue'
      // ),  //  待删除文件
      import(
        /*webpackChunkName:"behaviorManage2" */
        '@/views/behavior-manage/work-center/visit-activity/market-activity/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '活动详情',
      breadcrumb: [
        {
          title: '市场活动',
          name: 'behaviorManageBazaarActivityList',
        },
      ],
    },
  },
  // 行为管理 市场活动 上传附件
  {
    path: '/behaviorManage/bazaarActivity/uploadingAccessory/:id',
    name: 'behaviorManageBazaarActivityUploadingAccessory',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManage2" */
      //   '@/views/behaviorManage/bazaarActivity/UploadingAccessory.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManage2" */
        '@/views/behavior-manage/work-center/visit-activity/market-activity/Upload.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '上传活动附件',
      breadcrumb: [
        {
          title: '活动详情',
          name: 'behaviorManageBazaarActivityDetails',
        },
        {
          title: '市场活动',
          name: 'behaviorManageBazaarActivityList',
        },
      ],
    },
  },
  // OA 日常考勤
  {
    path: '/behaviorManage/work-attendance',
    name: 'behaviorManageWorkAttendance',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkAttendance" */
      //   '@/views/behaviorManage/work-attendance/Page.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageWorkAttendance" */
        '@/views/behavior-manage/work-center/visit-activity/daily-attendance/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '日常考勤',
    },
  },
  // OA 日常考勤 出差打卡天数导入
  {
    path: '/behaviorManage/evection-day-import',
    name: 'behaviorManageEvectionDayImport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkAttendance" */
      //   '@/views/behaviorManage/work-attendance/EvectionDayImport.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageWorkAttendance" */
        '@/views/behavior-manage/work-center/visit-activity/daily-attendance/Import.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '出差打卡天数导入',
      breadcrumb: [
        {
          title: '日常考勤',
          name: 'behaviorManageWorkAttendance',
        },
      ],
    },
  },
  // OA 日常考勤 考勤组管理
  {
    path: '/behaviorManage/work-attendance/group',
    name: 'behaviorManageWorkAttendanceGroup',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkAttendance" */
      //   '@/views/behaviorManage/work-attendance/Group.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageWorkAttendance" */
        '@/views/behavior-manage/work-center/visit-activity/daily-attendance/AttenGriopManage.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '考勤组管理',
      breadcrumb: [
        {
          title: '日常考勤',
          name: 'behaviorManageWorkAttendance',
        },
      ],
    },
  },

  // OA 日常考勤 添加编辑考勤
  {
    path: '/behaviorManage/work-attendance/setting/:meta_type/:crm_attendance_address_id',
    name: 'behaviorManageWorkAttendanceSetting',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkAttendance" */
      //   '@/views/behaviorManage/work-attendance/Setting.vue'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageWorkAttendance" */
        '@/views/behavior-manage/work-center/visit-activity/daily-attendance/Edit.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      isMoreMeta: true,
      1: {
        title: '添加考勤组',
        breadcrumb: [
          {
            title: '日常考勤',
            name: 'behaviorManageWorkAttendance',
          },
          {
            title: '考勤组管理',
            name: 'behaviorManageWorkAttendanceGroup',
          },
        ],
      },
      2: {
        title: '编辑考勤组',
        breadcrumb: [
          {
            title: '日常考勤',
            name: 'behaviorManageWorkAttendance',
          },
          {
            title: '考勤组管理',
            name: 'behaviorManageWorkAttendanceGroup',
          },
        ],
      },
    },
  },

  // OA 日常考勤 导出考勤
  {
    path: '/behaviorManage/work-attendance/export',
    name: 'behaviorManageWorkAttendanceExport',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageWorkAttendance" */
      //   '@/views/behaviorManage/work-attendance/Export.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageWorkAttendance" */
        '@/views/behavior-manage/work-center/visit-activity/daily-attendance/Export.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '导出考勤',
      breadcrumb: [
        {
          title: '日常考勤',
          name: 'behaviorManageWorkAttendance',
        },
      ],
    },
  },

  // 拜访活动 服务商准入
  {
    path: '/behaviorManage/service-provider-access-list',
    name: 'behaviorManageServiceProviderAccessList',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageOldHospitalSet" */
      //   '@/views/behaviorManage/ServiceProviderAccessList.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"behaviorManageOldHospitalSet" */
        '@/views/behavior-manage/work-center/visit-activity/service-provider-access/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '服务商准入',
    },
  },



  // 拜访活动 劳务规则配置
  {
    path: '/behaviorManage/work-center/visit-activity/labor-rules/page',
    name: 'behaviorManageLaborRules',
    component: () =>
      import(
        '@/views/behavior-manage/work-center/visit-activity/labor-rules/Page.vue'
        ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '劳务规则配置',
    },
  },
  // 拜访活动 劳务规则配置 导入
  {
    path: '/behaviorManage/work-center/visit-activity/labor-rules/import',
    name: 'behaviorManageLaborRulesImport',
    component: () =>
      import(
        '@/views/behavior-manage/work-center/visit-activity/labor-rules/Import.vue'
        ), //新迁移文件
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '导入劳务规则',
      breadcrumb: [
        {
          title: '劳务规则配置',
          name: 'behaviorManageLaborRules',
        },
      ],
    },
  },

  // 处方单列表
  {
    path: '/behaviorManage/prescription-page',
    name: 'behaviorManagePrescriptionPage',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageBusinessGuidance" */
      //   '@/views/behaviorManage/prescription-page/Page'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageBusinessGuidance" */
        '@/views/behavior-manage/work-center/visit-activity/prescription/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '处方单列表',
    },
  },

  // 处方单详情
  {
    path: '/behaviorManage/prescription-page/detail/:prescription_order_id',
    name: 'behaviorManagePrescriptionPageDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageBusinessGuidanceDetail" */
      //   '@/views/behaviorManage/prescription-page/Detail'
      // ),   //待删除文件
      import(
        /*webpackChunkName:"behaviorManageBusinessGuidanceDetail" */
        '@/views/behavior-manage/work-center/visit-activity/prescription/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: 'OA办公', //二级菜单
      title: '处方单详情',
      breadcrumb: [
        {
          title: '处方单列表',
          name: 'behaviorManagePrescriptionPage',
        },
      ],
    },
  },


  // 关注医院名单
  {
    path: '/behaviorManage/focus-hospital-list',
    name: 'behaviorManageFocusHospitalList',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageFocusHospitalList" */
        '@/views/behavior-manage/work-center/visit-activity/focus-hospital-list/Page.vue'
        ),
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '关注医院名单',
    },
  },
  // 关注医院名单 批量新增
  {
    path: '/behaviorManage/batch-add-focus-hospital',
    name: 'behaviorManageBatchAddFocusHospital',
    component: () =>
      import(
        /*webpackChunkName:"behaviorManageFocusHospitalList" */
        '@/views/behavior-manage/work-center/visit-activity/focus-hospital-list/Upload.vue'
        ),
    meta: {
      SecondaryMenu: '拜访活动', //二级菜单
      title: '批量新增',
      breadcrumb: [{
        title: '关注医院名单',
        name: 'behaviorManageFocusHospitalList',
      }, ],
    },
  },


]
export default visitActivityRouter
